export default __webpack_public_path__ + "static/screeny-55-gp-xs-6-8f4dbd97097a831fd1f3f468fa9cc39a.jpg";